var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1b54ce0881a67c7e39bac1e24330d6e224d0993f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seedlang@seedlang"]={id:"1b54ce0881a67c7e39bac1e24330d6e224d0993f"};
      